import { ComponentPropsWithoutRef } from 'react';

export const SecurityIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4 10 4v6c0 5.524-4.443 10.765-10 12ZM4 6v5a10.58 10.58 0 0 0 8 10 10.58 10.58 0 0 0 8-10V6l-8-3-8 3Z"
        fill="#000000"
      />
      <path
        d="M12 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7 15a5.78 5.78 0 0 0 5 3 5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3-1.667 0-4.975 1.104-5 3Z"
        fill="#000000"
      />
    </svg>
  );
};
